module.exports = __webpack_public_path__ + "img/logo1 (40).933a406c.jpg";